define('models/template/calendar/template-session',[
    'underscore', 'backbone', 'moment', 'utils',
    // parent
    'models/calendar/session'
], function(
    _, Backbone, moment, U,
    // parent
    MSession
) {

    var MTemplateSession = MSession.extend({
        defaults: function() {
            return {
                name: "",
                notes: "",
                num_weeks: 4,
                exercises: [],
            };
        },

        copyValues: function(model) {
            this.attributes.name = model.attributes.name;
            this.attributes.exercises = [];
            model.get('exercises').forEach(function(exercise) { this.attributes.exercises.push(JSON.parse(JSON.stringify(exercise))); }.bind(this));
            this.attributes.notes = model.attributes.notes;
            this.attributes.num_weeks = model.attributes.num_weeks;
        },

        getExercises: function() {
            return this.get('exercises');
        }
    });

    return MTemplateSession;
});

